import React from 'react';
import { Typography, Stack } from '@mui/material';

const ContactDetails = () => (

    <Stack gap="0.5rem">
      <Typography
        color="white"
        variant="body2"
        width={{ md:'75%', xl: 'max-content' }}
        maxWidth={{ md:'75%', xl: 'max-content' }}
        sx={{ wordWrap: 'break-word'}}
      >
        support@crossborderxpress.com
      </Typography>
    </Stack>
)

export default ContactDetails;
